import {
  AcquisitionWidget,
  BarChartWidget,
  CircleChartWidget,
  CounterWidget,
  ProgressTrackWidget,
  RankingWidget,
  SalesValueWidget,
  SalesValueWidgetPhone,
  TeamMembersWidget,
} from "../../components/Widgets";
import {
  Button,
  ButtonGroup,
  Card,
  Col,
  Dropdown,
  Row,
} from "@themesberg/react-bootstrap";
import React, { useEffect, useState } from "react";
import {
  faCogs,
  faGasPump,
  faUsers,
  faFileAlt,
  faClipboard,
  faBox,
} from "@fortawesome/free-solid-svg-icons";

import FeelingAngry from "../../assets/img/Feeling angry.gif";
import { getDashboardTotalCount } from "../../Service/DashboardTotalCount";
import swal from "sweetalert";
import ParentComponent from "../../components/Parent";
import OtpNavbarComp from "../../components/OtpNavbarComp";
// import TicketTechDashboard from "../TicketServiceComp/TicketServiceDashboardComp/TicketTechDashbaord";
// import TicketnonTechDashboard from "../TicketServiceComp/TicketServiceDashboardComp/TicketnonTechDashboard";
import TicketServiceNonTech from "../TicketServiceComp/TicketServiceNonTech";
import TicketServiceTech from "../TicketServiceComp/TicketServiceTech";
export default () => {
  const [totalCount, setTotalCount] = useState([]);
  const [role, setRole] = useState(sessionStorage.getItem("role"));
  const [modelName, setModelName] = useState(
    sessionStorage.getItem("moduleName")
  );


  const fname = sessionStorage.getItem('firstName');
  // const [totalServiceEngineer, setTotalServiceEngineer] = useState("totalServiceEngineer");
  useEffect(() => {
    setTimeout(async () => {
      getTotalCount(); // Function call to get all total count
    }, 200);
  }, []);

  const getTotalCount = async () => {
    try {
      const role = sessionStorage.getItem("role");
      const fkUserId = sessionStorage.getItem("pkUserId");
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      await getDashboardTotalCount(fkUserId, role, headers).then((result) => {
        // console.log("Dashboard Total Count", result);
        setTotalCount(result.data);
      });
    } catch (error) {
      //code to run if there are any problems
      // console.log("Error while getting dahsboard total count data", error);
      // swal(
      //   "Failed",
      //   // "Something went wrong please check your internet",
      //   "Data not Present in dashboard",
      //   "error"
      // );
    }
  };


  // After role of tech and nontech enable this code and in main dashboard it will replace so comment from sidebar 
  // tech and nontech dashboard
if (role === "tech person" || role === "nontech person") {
  return (
    <Row>
      <Col xs={12}>
        {role === "nontech person" ? <TicketServiceNonTech /> : <TicketServiceTech />}
      </Col>
    </Row>
  );
}

  // Sales Person Dashboard
  if (role === "Sales_person" || role === "RND_REVIEWER" || role === "PROCUREMENT_REVIEWER" || role === "FINANCE_REVIEWER" || role === "SLT_REVIEWER" || role === "PRODUCTION_REVIEWER") {
    return (
      <>
        {/* Funnel Status */}
        <Row className="justify-content">
          <div className="dash_head d-flex justify-content-space-arround">
            <h3 className="m-2">Funnel Status</h3>
          </div>
          <Col xs={12} sm={6} xl={4} className="mb-4">
            <CounterWidget
              category="Draft"
              title="5"
              icon={faFileAlt}
            />
          </Col>
          <Col xs={12} sm={6} xl={4} className="mb-4">
            <CounterWidget
              category="Under Approval"
              title="8"
              icon={faFileAlt}
            />
          </Col>
          <Col xs={12} sm={6} xl={4} className="mb-4">
            <CounterWidget
              category="Approved"
              title="12"
              icon={faFileAlt}
            />
          </Col>
        </Row>

        {/* Marketing Tools */}
        <Row className="justify-content">
          <div className="dash_head d-flex justify-content-space-arround">
            <h3 className="m-2">Marketing Tools</h3>
          </div>
          <Col xs={12} sm={6} xl={4} className="mb-4">
            <CounterWidget
              category="Presentation"
              title="15"
              icon={faClipboard}
            />
          </Col>
          <Col xs={12} sm={6} xl={4} className="mb-4">
            <CounterWidget
              category="Product Brochure"
              title="20"
              icon={faBox}
            />
          </Col>
          <Col xs={12} sm={6} xl={4} className="mb-4">
            <CounterWidget
              category="Proposal Format"
              title="10"
              icon={faFileAlt}
            />
          </Col>
        </Row>

        {/* My Orders */}
        <Row className="justify-content">
          <div className="dash_head d-flex justify-content-space-arround">
            <h3 className="m-2">My Orders</h3>
          </div>
          <Col xs={12} sm={6} xl={4} className="mb-4">
            <CounterWidget
              category="Under Production"
              title="3"
              icon={faGasPump}
            />
          </Col>
          <Col xs={12} sm={6} xl={4} className="mb-4">
            <CounterWidget
              category="Under Installation"
              title="2"
              icon={faGasPump}
            />
          </Col>
          <Col xs={12} sm={6} xl={4} className="mb-4">
            <CounterWidget
              category="Completed"
              title="18"
              icon={faGasPump}
            />
          </Col>
        </Row>
      </>
    );
  }

  
  
  return (
    <>
      {role === "service engineer" ? (
        <>
          <Row className="justify-content">
            {modelName.includes("SEInstall") ? (
              <>
                <div className="dash_head d-flex justify-content-space-arround">
                  <h3 className="m-2">Installation</h3>{role !== "admin" ? <h3 className="dash_head mt-2">  by me</h3> : ""}
                </div>
                <Col xs={12} sm={6} xl={4} className="mb-4">
                  <CounterWidget
                    category="Installation-Open WO"
                    title={totalCount.openWorkOrder}
                    icon={faGasPump}
                  />
                </Col>
                <Col xs={12} sm={6} xl={4} className="mb-4">
                  <CounterWidget
                    category="Installation-Close WO"
                    title={totalCount.closeWorkOrder}
                    icon={faGasPump}
                  />
                </Col>
                <Col xs={12} sm={6} xl={4} className="mb-4">
                  <CounterWidget
                    category="Installation-Total WO"
                    title={totalCount.totalWorkOrder}
                    icon={faGasPump}
                  />
                </Col>
              </>
            ) : (
              ""
            )}
            {modelName.includes("SECalibration") ? (
              <>
                <div className="dash_head d-flex justify-content-space-arround">
                  <h3 className="m-2">Calibration</h3>{role !== "admin" ? <h3 className="dash_head mt-2">  by me</h3> : ""}
                </div>
                <Col xs={12} sm={6} xl={4} className="mb-4">
                  <CounterWidget
                    category="Calibration-Open WO"
                    title={totalCount.openCalibration}
                    icon={faGasPump}
                  />
                </Col>
                <Col xs={12} sm={6} xl={4} className="mb-4">
                  <CounterWidget
                    category="Calibration-Closed WO"
                    title={totalCount.closeCalibration}
                    icon={faGasPump}
                  />
                </Col>
                <Col xs={12} sm={6} xl={4} className="mb-4">
                  <CounterWidget
                    category="Calibration-Total WO"
                    title={totalCount.totalCalibration}
                    icon={faGasPump}
                  />
                </Col>
              </>
            ) : (
              ""
            )}
            {modelName.includes("SEField Job") ? (
              <>
                <div className="dash_head d-flex justify-content-space-arround">
                  <h3 className="m-2">Field Job</h3>{role !== "admin" ? <h3 className="dash_head mt-2">  by me</h3> : ""}
                </div>
                <Col xs={12} sm={6} xl={4} className="mb-4">
                  <CounterWidget
                    category="Field Job-Open WO"
                    title={totalCount.openFieldVisit}
                    icon={faGasPump}
                  />
                </Col>
                <Col xs={12} sm={6} xl={4} className="mb-4">
                  <CounterWidget
                    category="Field Job-Closed WO"
                    title={totalCount.closeFieldVisit}
                    icon={faGasPump}
                  />
                </Col>
                <Col xs={12} sm={6} xl={4} className="mb-4">
                  <CounterWidget
                    category="Field Job-Total WO"
                    title={totalCount.totalFieldVisit}
                    icon={faGasPump}
                  />
                </Col>
              </>
            ) : (
              ""
            )}
          </Row>
        </>
      ) : (
        <Row className="justify-content">
          {role === "admin" ? (
            <Col xs={12} sm={6} xl={3} className="mb-4">
              <CounterWidget
                category="Customers"
                title={totalCount.totalCustomer}
                icon={faUsers}
              />
            </Col>
          ) : (
            ""
          )}
          {role === "admin" ? (
            <Col xs={12} sm={6} xl={3} className="mb-4">
              <CounterWidget
                category="Romanager"
                title={totalCount.totalRomanager}
                icon={faUsers}
              />
            </Col>
          ) : role === "customer" ? (
            <Col xs={12} sm={6} xl={4} className="mb-4">
              <CounterWidget
                category="Romanager"
                title={totalCount.totalRomanager}
                icon={faUsers}
              />
            </Col>
          ) : (
            ""
          )}
          {role === "admin" ? (
            <>
              <Col xs={12} sm={6} xl={3} className="mb-4">
                <CounterWidget
                  category="Service Engineer"
                  title={totalCount.totalServiceEngineer}
                  icon={faUsers}
                />
              </Col>
              <Col xs={12} sm={6} xl={3} className="mb-4">
                <CounterWidget
                  category="Back Office User"
                  title={totalCount.totalBackOffice}
                  icon={faUsers}
                />
              </Col>
            </>
          ) : (
            ""
          )}
  {
                role === "customer" ?  <Col xs={12} sm={6} xl={3} className="mb-4"><OtpNavbarComp/></Col> : null
              }
          <div className="dash_head d-flex justify-content-space-arround">
            <h3 className="m-2">Installation</h3>{role !== "admin" ? <h3 className="dash_head mt-2"> by me</h3> : <h3 className="dash_head mt-2">  By All</h3>}
          </div>
          <Col xs={12} sm={6} xl={4} className="mb-4">
            <CounterWidget
              category="Installation-Open WO"
              title={totalCount.openWorkOrder}
              icon={faGasPump}
            />
          </Col>
          <Col xs={12} sm={6} xl={4} className="mb-4">
            <CounterWidget
              category="Installation-Closed WO"
              title={totalCount.closeWorkOrder}
              icon={faGasPump}
            />
          </Col>
          <Col xs={12} sm={6} xl={4} className="mb-4">
            <CounterWidget
              category="Installation-Total WO"
              title={totalCount.totalWorkOrder}
              icon={faGasPump}
            />
          </Col>
          <div className="dash_head d-flex justify-content-space-arround">
            <h3 className="m-2">Calibration</h3>{role !== "admin" ? <h3 className="dash_head mt-2">  by me</h3> : <h3 className="dash_head mt-2">  By All</h3>}
          </div>
          <Col xs={12} sm={6} xl={4} className="mb-4">
            <CounterWidget
              category="Calibration-Open WO"
              title={totalCount.openCalibration}
              icon={faGasPump}
            />
          </Col>
          <Col xs={12} sm={6} xl={4} className="mb-4">
            <CounterWidget
              category="Calibration-Closed WO"
              title={totalCount.closeCalibration}
              icon={faGasPump}
            />
          </Col>
          <Col xs={12} sm={6} xl={4} className="mb-4">
            <CounterWidget
              category="Calibration-Total WO"
              title={totalCount.totalCalibration}
              icon={faGasPump}
            />
          </Col>


          <div className="dash_head d-flex justify-content-space-arround">
            <h3 className="m-2">Field Job</h3>{role !== "admin" ? <h3 className="dash_head mt-2">  by me</h3> :  <h3 className="dash_head mt-2">  By All</h3>}
          </div>
          <Col xs={12} sm={6} xl={4} className="mb-4">
            <CounterWidget
              category="Field Job-Open WO"
              title={totalCount.openFieldVisit}
              icon={faGasPump}
            />
          </Col>
          <Col xs={12} sm={6} xl={4} className="mb-4">
            <CounterWidget
              category="Field Job-Closed WO"
              title={totalCount.closeFieldVisit}
              icon={faGasPump}
            />
          </Col>
          <Col xs={12} sm={6} xl={4} className="mb-4">
            <CounterWidget
              category="Field Job-Total WO"
              title={totalCount.totalFieldVisit}
              icon={faGasPump}
            />
          </Col>


          {/*  <Col xs={12} sm={6} xl={4} className="mb-4">
            <CounterWidget
              category="Open Field"
              title={totalCount.openFieldVisit}
              icon={faChartLine}
              //iconColor="shape-secondary"
            />
          </Col>
          <Col xs={12} sm={6} xl={4} className="mb-4">
            <CounterWidget
              category="Close Field"
              title={totalCount.closeFieldVisit}
              icon={faCashRegister}
            />
          </Col> */}
          {role === "admin" || role === "back office" ? (
            <>
              {/* <Col xs={12} sm={6} xl={4} className="mb-4">
                <CounterWidget
                  // category="Complete Service"
                  category="Complete Service"
                  title={totalCount.completeService}
                  icon={faCogs}
                />
              </Col>
              <Col xs={12} sm={6} xl={4} className="mb-4">
                <CounterWidget
                  category="Installed Dispenser"
                  title={totalCount.installedDispenser}
                  icon={faGasPump}
                />
              </Col> */}
            </>
          ) : (
            ""
          )}
        </Row>
      )}
      {role === "service engineer" ? (
        <>
          {modelName.includes("SEInstall") ||
            modelName.includes("SEField Job") ||
            modelName.includes("SECalibration") ||
            modelName.includes("REServices") ? (
            ""
          ) : (
            <Card border="light" className="bg-white shadow-sm mb-4">
              <Card.Body>
                <h5 className="head mb-4">
                  You don't have access of any module contact admin or back
                  office.
                </h5>
                <div className="not-scanned">
                  <img src={FeelingAngry} alt="bg-img" />
                </div>
              </Card.Body>
            </Card>
          )}
        </>
      ) : (
        ""
      )}
      {/* <ParentComponent/> */}
    </>
  );
};
